import { useEffect, useState } from 'react';
import throttle from 'lodash/throttle';
import checkVisibility from '../checkVisibility';

const throttleInterval = 150;

const useVisibility = (el, { partial = false, scrollableEl = window } = {}) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (el) {
        const handleScrollOrResize = throttle(
            () => setIsVisible(checkVisibility(el, partial)),
            throttleInterval,
          );

          if(scrollableEl) scrollableEl.addEventListener('scroll', handleScrollOrResize);
          window.addEventListener('resize', handleScrollOrResize);

          setIsVisible(checkVisibility(el, partial));

          return () => {
            if(scrollableEl) scrollableEl.removeEventListener('scroll', handleScrollOrResize);
            window.removeEventListener('resize', handleScrollOrResize);
          };
    }
  }, [el, partial, scrollableEl]);

  return isVisible;
};

export default useVisibility;